import { PropsWithChildren } from 'react';

import { Sidebar } from '@/widgets';

import styles from './dashboard-layout.module.scss';

export function DashboardLayout(props: PropsWithChildren) {
  return (
    <div className={styles.container}>
      <Sidebar />
      <div className={styles.content}>{props.children}</div>
    </div>
  );
}
